import styled from 'styled-components'

export const ModelSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 12px;

  .model-dropdown {
    height: 40px;
  }
`

export const ModelOptionsWrapper = styled.div`
  display: flex;
  gap: 10px;

  > *:first-child {
    flex: 2 1 0;
    min-width: 0;
  }

  > *:last-child {
    flex: 1 1 0;
    min-width: 0;
  }

  .option-dropdown {
    height: 40px;
  }
`

export const ScopeCheckboxWrapper = styled.div`
  .scope-checkbox-label {
    font-size: 14px;
    font-weight: 500;
  }

  .scope-checkbox-label p {
    font-size: inherit;
  }
`
